// extracted by mini-css-extract-plugin
export var body = "Pageheader-module--body--eea50";